const BackIcon = props => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52.5 90.2' {...props}>
      <path d='m45.03,85.2c-.62,0-1.18-.24-1.65-.72L5.71,46.81c-.62-.62-.71-1.33-.71-1.71s.09-1.09.71-1.71L43.38,5.72c.48-.48,1.04-.72,1.65-.72.95,0,2.47.66,2.47,2.43v75.34c0,1.77-1.51,2.43-2.47,2.43m0,5c3.81,0,7.47-2.96,7.47-7.43V7.43c0-4.47-3.66-7.43-7.47-7.43-1.82,0-3.68.68-5.19,2.19L2.17,39.85c-2.9,2.9-2.9,7.59,0,10.49l37.67,37.67c1.51,1.51,3.37,2.19,5.19,2.19h0Z' />
    </svg>
  );
};

export default BackIcon;
